import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  MODAL_ADMIN_EDIT_CATEGORY,
  MODAL_ADMIN_CREATE_CATEGORY,
  MODAL_ADMIN_DELETE_CATEGORY,
  MODAL_ADMIN_REORDER_CATEGORY
} from 'redux/modules/modals'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
const transformTaxe = taxe => Number(taxe.tax_value) * 100
const columnData = [
  { id: 'name', numeric: false, disablePadding: false, label: 'Nom' },
  {
    id: 'tva',
    numeric: true,
    disablePadding: false,
    label: 'TVA par défaut (%)',
    transform: transformTaxe
  },
  { id: 'color', numeric: true, disablePadding: false, label: 'Couleur' },
  {
    id: 'order',
    numeric: true,
    disablePadding: false,
    label: "Ordre d'affichage"
  }
]
export default class AdminCategoriesComponent extends Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    showModal: PropTypes.func.isRequired
  }

  handleCreateCategoryClick = () => {
    this.props.showModal(MODAL_ADMIN_CREATE_CATEGORY)
  }
  handleEditCategoryClick = category => {
    this.props.showModal(MODAL_ADMIN_EDIT_CATEGORY, category)
  }
  handleDeleteClick = category => {
    this.props.showModal(MODAL_ADMIN_DELETE_CATEGORY, category)
  }
  handleReorderClick = () => {
    this.props.showModal(MODAL_ADMIN_REORDER_CATEGORY, this.props.categories)
  }
  componentDidMount() {}
  render() {
    const { categories } = this.props
    return (
      <div className="pageAdmin">
        <AdminTableComponent
          title="Catégories"
          selectable
          list={categories}
          orderBy={'order'}
          columnData={columnData}
          addButtonAction={this.handleCreateCategoryClick}
          editButtonAction={this.handleEditCategoryClick}
          reOrderAction={this.handleReorderClick}
          deleteButtonAction={this.handleDeleteClick}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Categories/components/AdminCategoriesComponent.js